import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { contact, navItems } from '../data/site';
export function SiteFooter() {
  return <footer className="bg-ink text-ivory" data-id="element-126" data-mp="3mh1206y44y0m">
      <div className="mx-auto grid max-w-page gap-12 px-6 py-16 lg:grid-cols-[1.3fr_1fr_1fr] lg:px-10 lg:py-20" data-id="element-127" data-mp="3mfq0kds542co">
        <div data-id="element-128" data-mp="3hgddpt19qva3">
          <p className="font-serif text-2xl" data-id="element-129" data-mp="3dgutz0l6oq8u">Christine Velluet</p>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-ivory/70" data-id="element-130" data-mp="3difm6jk0zx3j">
            Éducatrice sportive — Pilates, Stretching Postural® méthode Jean-Pierre Moreau et Munz Floor®.
            Un accompagnement du corps, progressif et sans comparaison.
          </p>
        </div>

        <nav aria-label="Pages du site" data-id="element-131" data-mp="2ykvnfudq2y5t">
          <h2 className="text-xs uppercase tracking-[0.2em] text-ivory/50" data-id="element-132" data-mp="2ylyf44ivd4ms">Le site</h2>
          <ul className="mt-5 space-y-3 text-sm" data-id="element-133" data-mp="11p7mrlypyvce">
            <li data-id="element-134" data-mp="wrz4zmhhgtbo">
              <Link to="/" className="text-ivory/80 transition-colors duration-150 ease-soft hover:text-ivory" data-id="element-135" data-mp="wtikvbz892cx">
                Accueil
              </Link>
            </li>
            {navItems.map(item => <li key={item.to} data-id="element-136" data-mp="1ar9ikomei5ge">
                <Link to={item.to} className="text-ivory/80 transition-colors duration-150 ease-soft hover:text-ivory" data-id="element-137" data-mp="vsp9ssaqbvf3">
                  {item.label}
                </Link>
              </li>)}
            <li data-id="element-138" data-mp="1ohmqws37fm69">
              <Link to="/contact" className="text-ivory/80 transition-colors duration-150 ease-soft hover:text-ivory" data-id="element-139" data-mp="1oh36n4q30lp2">
                Contact
              </Link>
            </li>
          </ul>
        </nav>

        <div data-id="element-140" data-mp="1eqibjr9m9zaw">
          <h2 className="text-xs uppercase tracking-[0.2em] text-ivory/50" data-id="element-141" data-mp="1eqs3vli4wijr">Me joindre</h2>
          <ul className="mt-5 space-y-3 text-sm text-ivory/80" data-id="element-142" data-mp="1jpl7mm7mcv6q">
            <li className="flex items-start gap-3" data-id="element-143" data-mp="27gh6226kyomy">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-144" data-mp="27enzsnzvq6fh" />
              {contact.address}
            </li>
            <li className="flex items-start gap-3" data-id="element-145" data-mp="2m2xsab0sruhm">
              <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-146" data-mp="2m2e6ukbxunyu" />
              <a href={`tel:${contact.phone.replace(/\s/g, '')}`} className="hover:text-ivory" data-id="element-147" data-mp="2h54k5cfxoqep">
                {contact.phone}
              </a>
            </li>
            <li className="flex items-start gap-3" data-id="element-148" data-mp="283eqs12hrhea">
              <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-149" data-mp="282vbks48773y" />
              <a href={`mailto:${contact.email}`} className="hover:text-ivory" data-id="element-150" data-mp="235mp4fc1ogww">
                {contact.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-ivory/10" data-id="element-151" data-mp="1tf1vz7f544ld">
        <div className="mx-auto flex max-w-page flex-col gap-2 px-6 py-6 text-xs text-ivory/50 sm:flex-row sm:items-center sm:justify-between lg:px-10" data-id="element-152" data-mp="1pcndiofdv6um">
          <p data-id="element-153" data-mp="1kc95h6ds7wwl">© {new Date().getFullYear()} Christine Velluet. Tous droits réservés.</p>
          <p data-id="element-154" data-mp="1ffipej1z91b6">Mentions légales · Conditions de vente</p>
        </div>
      </div>
    </footer>;
}